<template>
  <div>
    <vue-scroll class="page-dashboard">
      <rabbey-toolbox
        :call-new="callNew"
        v-if="
          IsInRoles([
            roles.GerenteDeSoporte,
            roles.SuperUsuario,
            roles.EncargadaCompras,
            roles.GerenteRRHH,
            roles.SupervisorDeTécnicos,
            roles.GerenciaGeneral,
            roles.CoordinadorIso,
            roles.DirectorDeProyectos,
            roles.CoordinadorDeSoporte,
            roles.DirectorAdministrativo,
            roles.CoornidadorDeServicioAlCliente,
            roles.EncargadoDesarrolloDeAplicaciones,
            ,
            roles.CEO,
            roles.SupervisorDeSoporteDeVentas,
            roles.SupervisorDeVentas
          ])
        "
      />

      <el-row>
        <el-col>
          <rabbey-toolbox :filterables="true" @filter-search="search = $event">
          </rabbey-toolbox>
          <rabbey-table3
            ref="table"
            :data="items"
            :columns="columns"
            :search="search"
            :actions="actions"
            :loading="loading"
            @rtable-push-action="actionHandler"
            @update-page-size="updatePageSize"
            @update-current-page="updateCurrentPage"
          />
        </el-col>
      </el-row>
    </vue-scroll>

    <el-drawer
      :title="title"
      :visible.sync="legal_visible"
      direction="rtl"
      size="29%"
    >
      <div
        class="flex gaps column demo-drawer__content border-myborder"
        style="padding: 20px"
      >
        <div id="div-legal">
          <NewDocument
            class="scrollable"
            style="max-height: 800px"
            :Visible="legal_visible"
            ref="myDocument"
            @dialog-closed="legal_visible = false"
            @success="getTableData"
          ></NewDocument>
        </div>
      </div>
    </el-drawer>

    <el-dialog title="Confirmación" :visible.sync="dialogVisible" width="10%">
      <span>¿Está seguro de eliminar este archivo?</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" type="danger" size="mini"
          >Cancelar</el-button
        >
        <el-button type="primary" @click="deleteFile" size="mini"
          >Sí, eliminar</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import NewDocument from "@/views/apps/cmi/documents/NewDocument.vue";

//import ImagePerson from "../components/functionals/ImagePerson.vue";

export default {
  name: "DocumentList",
  components: {
    NewDocument
  },
  created() {
    this.getTableData();
  },
  data() {
    return {
      dialogVisible: false,
      fileId: 0,
      selectedFile: 0,
      fileCreatedBy: 0,
      currentPage: 1,
      pageSize: 10,
      search: "",
      items: [],
      itemId: -1,
      loading: false,
      legal_visible: false,
      title: "",
      columns: [
        {
          prop: "Id",
          label: "NO",
          width: 80,
          sortable: true
        },
        {
          prop: "FolderName",
          label: "Descripcion",
          sortable: true
          // sortable: true,
          // formatter: row => {
          //   return row.ISODocumentProcess.Name;
          // }
        },
        {
          prop: "CreatedAt",
          label: "Fecha de creacion",
          sortable: true,
          formatter: DatetimeFormatter
        },
        {
          prop: "AttachmentFileName",
          label: "Nombre del archivo",
          sortable: true
          // sortable: true,
          // formatter: row => {
          //   return row.ISODocumentProcess.Name;
          // }
        }
        // {
        //   prop: "AttachmentUrl",
        //   label: "Documento",
        //   width: 150,
        //   sortable: true,
        //   formatter: DownLoadFile
        // }
      ],
      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view"
        },
        {
          icon: "el-icon-delete",
          label: "Eliminar",
          command: "delete"
        }
      ]
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      //for getting the data of the table for the first time
      const table = this.$refs.table;
      const config = {
        params: {
          "criteria.CompanyCode": this.$store.state.user.user.CompanySelected,
          "criteria.Page": table.pagination.currentPage,
          "criteria.Limit": table.pagination.pageSize,
          "criteria.Modulo": "CMI"
        }
      };
      table.indexConfig = config;
    },
    callNew() {
      this.title = "Nueva carpeta de archivos";
      this.legal_visible = true;
    },
    getTableData() {
      this.loading = true;
      this.$http
        .get("/api/Folder/allDocuments", {
          params: {
            "criteria.CompanyCode": this.currentCompany,
            "criteria.Page": this.currentPage,
            "criteria.Limit": this.pageSize,
            "criteria.Modulo": "CMI",
            "criteria.DirecctionsID": this.$store.state.user.user.DireccionID
          }
        })
        .then((response) => {
          this.items = response.data.Items;
          //console.log("VAINA USER: ", this.$store.state.user.user)
        })
        .finally(() => (this.loading = false));
    },
    actionHandler(action) {
      switch (action.command) {
        case "view": {
          this.downloadFile(action.row.AttachmentUrl);
          break;
        }
        case "delete": {
          if (
            this.IsInRoles([
              this.roles.GerenteDeSoporte,
              this.roles.SuperUsuario,
              this.roles.EncargadaCompras,
              this.roles.GerenteRRHH,
              this.roles.SupervisorDeTécnicos,
              this.roles.GerenciaGeneral,
              this.roles.CoordinadorIso,
              this.roles.DirectorDeProyectos,
              this.roles.CoordinadorDeSoporte,
              this.roles.DirectorAdministrativo,
              this.roles.CoornidadorDeServicioAlCliente,
              this.roles.EncargadoDesarrolloDeAplicaciones,

              this.roles.CEO,
              this.roles.SupervisorDeSoporteDeVentas,
              this.roles.SupervisorDeVentas
            ])
          ) {
            this.dialogVisible = true;
            this.fileId = action.row.FileId;
            this.fileCreatedBy = action.row.CreatedBy;
            this.selectedFile = action.row.FileId;
          } else {
            this.$message.error(
              "No tienes permiso para eliminar este documento"
            );
          }
          break;
        }
      }
    },
    downloadFile(file) {
      let link = document.createElement("a");
      link.href = file;
      link.download = "download";
      link.target = "_blank";
      link.click();
    },
    deleteFile() {
      this.$http
        .get("/api/Folder/deleteDocumentAllType", {
          timeout: 3 * 60 * 1000,
          params: {
            "criteria.FileId": this.fileId,
            "criteria.CreatedBy": this.fileCreatedBy,
            "criteria.CurrentUserId": this.currentUser.UserID
          }
        })
        .then((response) => {
          if (response.data.Succeded) {
            let files = this.items.map(
              (item) => item.FileId == this.selectedFile
            );
            let deletedFileId = files.indexOf(true); //getting the id of the clicked item for deletion
            this.items.splice(deletedFileId, 1);
            this.$message({
              type: "success",
              message: "El archivo fue eliminado exitosamente"
            });
          } else {
            this.$message.error("Solo el creador del archivo puede eliminarlo");
          }
        });
      this.dialogVisible = false;
    },
    updatePageSize(val) {
      this.pageSize = val;
      this.getTableData();
    },
    updateCurrentPage(val) {
      this.currentPage = val;
      this.getTableData();
    }
  }
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}
</style>
